<ng-template #main>
  <wlm-default-filter-item-select
    *ngIf="!hide && elementList"
    [title]="titleKey | translate"
    [options]="elementList"
    [clearAll$]="clearAll$"
    [selectAll$]="selectAll$"
    [restoreStatus$]="restoreState$"
    [saveInitStatus$]="saveInitStatus$"
    [filterText]="filterText"
    [settings]="settings"
    [selectedIds]="selectedIds"
    [defaultSelectedIds]="defaultSelectedElements"
    [mode]="mode"
    (initRestore)="onInitRestore()"
    (select)="onSelected($event)"
  ></wlm-default-filter-item-select>
</ng-template>
<ng-template #summary>
  <wlm-default-filter-item-summary
    *ngIf="!hide && titleKey"
    [title]="titleKey | translate"
    [items]="selectedElements"
  >
  </wlm-default-filter-item-summary>
</ng-template>
